import api from "!../../../../../node_modules/.pnpm/style-loader@2.0.0_webpack@5.106.2/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.106.2/node_modules/css-loader/dist/cjs.js??clonedRuleSet-9.use[1]!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_webpack@5.106.2__lodash@4.18.1_prettier@2.8.8_vue-t_4005a65e67acd77eac1bc9f1c137ca40/node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../node_modules/.pnpm/postcss-loader@6.2.1_postcss@8.5.28_webpack@5.106.2/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-9.use[2]!../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@5.2.7_webpack@5.106.2__lodash@4.18.1_prettier@2.8.8_vue-t_4005a65e67acd77eac1bc9f1c137ca40/node_modules/vue-loader/lib/index.js??vue-loader-options!./SidebarItem.vue?vue&type=style&index=0&id=62b88656&prod&scoped=true&lang=css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};